var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellPlusLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.19,
    height: 40.5,
    viewBox: "0 0 56.19 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BellPlus-LogoWhite",
    transform: "translate(-646.703 -746.077)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    transform: "translate(669.084 770.018)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(646.703 758.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M660.814,915.247a8.374,8.374,0,0,0-2.612-1.766h0a8.073,8.073,0,0,0-3.221-.645h-4.748v-6.5H646.7V921.08a8.105,8.105,0,0,0,.644,3.2,8.342,8.342,0,0,0,4.432,4.432,8.322,8.322,0,0,0,6.423,0,8.208,8.208,0,0,0,2.612-1.785,8.528,8.528,0,0,0,1.765-2.647,8.324,8.324,0,0,0,0-6.422A8.373,8.373,0,0,0,660.814,915.247Zm-5.832,10.58a4.721,4.721,0,0,1-4.748-4.748v-4.712h4.748a4.626,4.626,0,0,1,1.831.366,4.741,4.741,0,0,1,2.514,2.515,4.623,4.623,0,0,1,.366,1.832,4.718,4.718,0,0,1-2.88,4.382A4.624,4.624,0,0,1,654.982,925.827Z",
    transform: "translate(-646.703 -906.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M880.445,999.415a4.647,4.647,0,0,1-5.207,1l8.938-8.938-1.232-1.232a8.107,8.107,0,0,0-2.742-1.822,8.3,8.3,0,0,0-6.216,0,8.105,8.105,0,0,0-2.742,1.822,7.913,7.913,0,0,0-1.8,2.725,8.464,8.464,0,0,0-.588,3.089,8.6,8.6,0,0,0,.588,3.106,7.873,7.873,0,0,0,1.8,2.744,8.248,8.248,0,0,0,11.7,0l1.232-1.231-2.5-2.5Zm-6.928-6.928Zm3.521-1.15a4.66,4.66,0,0,1,1.911.408c-.335.334-.76.752-1.264,1.246-.635.623-1.279,1.261-1.913,1.9l-3.033,3.033a4.544,4.544,0,0,1-.393-1.856,4.59,4.59,0,0,1,1.4-3.351h0a4.5,4.5,0,0,1,2.6-1.326A4.985,4.985,0,0,1,877.038,991.337Z",
    transform: "translate(-851.135 -981.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3.53,
    height: 23.016,
    transform: "translate(34.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 3.53,
    height: 23.016,
    transform: "translate(40.226)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1164.307,752.708h-6.631v-6.631h-2.942v6.631H1148.1v2.942h6.631v6.632h2.942V755.65h6.631Z",
    transform: "translate(-461.414 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(646.869 784.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M649.176,1230.12l.431,1.475.428-1.475h.353l.431,1.475.426-1.475h.37l-.621,1.874h-.372l-.418-1.406-.423,1.406h-.37l-.621-1.874Z",
    transform: "translate(-648.79 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M688.171,1230.12v.313h-1.015v.463h.91v.313h-.91v.471H688.2v.313H686.8v-1.874Z",
    transform: "translate(-683.766 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M717.732,1230.246c-.169,0-.278.062-.278.177,0,.38,1.007.174,1,.846,0,.351-.305.554-.718.554a1.216,1.216,0,0,1-.792-.3l.15-.3a1.055,1.055,0,0,0,.648.276c.2,0,.321-.075.321-.206,0-.391-1.007-.169-1.007-.835,0-.327.281-.535.7-.535a1.276,1.276,0,0,1,.677.2l-.145.311A1.2,1.2,0,0,0,717.732,1230.246Z",
    transform: "translate(-711.513 -1229.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M740.507,1230.12v.8h.934v-.8h.359v1.874h-.359v-.76h-.934v.76h-.359v-1.874Z",
    transform: "translate(-732.862 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M766.823,1230.933a1,1,0,1,1-1-.948A.961.961,0,0,1,766.823,1230.933Zm-1.63,0a.636.636,0,0,0,.637.632.629.629,0,1,0-.637-.632Z",
    transform: "translate(-755.572 -1229.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M794.2,1231.689a.434.434,0,0,0,.463-.476v-1.093h.359v1.093a.828.828,0,0,1-1.655,0v-1.093h.359v1.093A.443.443,0,0,0,794.2,1231.689Z",
    transform: "translate(-781.835 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M818.33,1230.12v.319h-.584v1.556h-.362v-1.556H816.8v-.319Z",
    transform: "translate(-803.402 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M849.385,1230.933a1,1,0,1,1-1-.948A.961.961,0,0,1,849.385,1230.933Zm-1.631,0a.636.636,0,0,0,.637.632.629.629,0,1,0-.637-.632Z",
    transform: "translate(-831.55 -1229.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M876.76,1231.689a.434.434,0,0,0,.463-.476v-1.093h.359v1.093a.828.828,0,0,1-1.655,0v-1.093h.359v1.093A.443.443,0,0,0,876.76,1231.689Z",
    transform: "translate(-857.813 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M900.892,1230.12v.319h-.584v1.556h-.362v-1.556h-.583v-.319Z",
    transform: "translate(-879.38 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M929.933,1231.381v.613h-.359v-.6l-.7-1.274h.364l.511.881.5-.881h.361Z",
    transform: "translate(-906.539 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M953.637,1230.933a1,1,0,1,1-1-.948A.961.961,0,0,1,953.637,1230.933Zm-1.63,0a.636.636,0,0,0,.637.632.629.629,0,1,0-.637-.632Z",
    transform: "translate(-927.488 -1229.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M981.012,1231.689a.434.434,0,0,0,.463-.476v-1.093h.359v1.093a.828.828,0,0,1-1.655,0v-1.093h.359v1.093A.443.443,0,0,0,981.012,1231.689Z",
    transform: "translate(-953.751 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1007.406,1231.994l-.324-.554a.49.49,0,0,1-.067,0h-.423v.551h-.359v-1.874h.782c.485,0,.76.233.76.645a.61.61,0,0,1-.372.608l.412.621Zm-.814-.868h.423c.268,0,.418-.115.418-.351s-.15-.343-.418-.343h-.423Z",
    transform: "translate(-977.727 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1042.059,1230.589a.411.411,0,0,1-.327.415.458.458,0,0,1,.4.474c0,.321-.265.517-.693.517h-.857v-1.874h.833C1041.813,1230.12,1042.059,1230.3,1042.059,1230.589Zm-.367.064c0-.142-.112-.225-.3-.222h-.455v.455h.455C1041.58,1230.886,1041.692,1230.8,1041.692,1230.653Zm.067.779c0-.153-.136-.246-.364-.244h-.455v.5h.455C1041.623,1231.686,1041.759,1231.593,1041.759,1231.432Z",
    transform: "translate(-1009.336 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1065.559,1231.994l-.324-.554a.489.489,0,0,1-.067,0h-.423v.551h-.359v-1.874h.782c.485,0,.76.233.76.645a.61.61,0,0,1-.372.608l.412.621Zm-.814-.868h.423c.268,0,.418-.115.418-.351s-.15-.343-.418-.343h-.423Z",
    transform: "translate(-1031.243 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1087.194,1231.6h-.916l-.166.4h-.372l.822-1.874h.372l.811,1.874h-.385Zm-.129-.308-.327-.787-.332.787Z",
    transform: "translate(-1050.894 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1114.082,1230.12l.966,1.282v-1.282h.348v1.874h-.34l-.964-1.28v1.28h-.351v-1.874Z",
    transform: "translate(-1076.663 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1142.022,1231.057a.929.929,0,0,1-.991.937h-.766v-1.874h.779A.922.922,0,0,1,1142.022,1231.057Zm-.367,0a.6.6,0,0,0-.616-.624h-.415v1.242h.429A.589.589,0,0,0,1141.656,1231.06Z",
    transform: "translate(-1101.072 -1230.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1164.372,1249.279a.184.184,0,1,1-.367,0,.184.184,0,1,1,.367,0Z",
    transform: "translate(-1122.917 -1247.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1171.926,1249.279a.184.184,0,1,1-.367,0,.184.184,0,1,1,.367,0Z",
    transform: "translate(-1129.869 -1247.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1179.85,1232.039a.184.184,0,1,1-.367,0,.183.183,0,1,1,.367,0Zm-.016-1.684v.466l-.059.779h-.217l-.059-.779v-.466Z",
    transform: "translate(-1137.161 -1230.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1187.3,1232.039a.184.184,0,1,1-.367,0,.184.184,0,1,1,.367,0Zm-.016-1.684v.466l-.059.779h-.217l-.059-.779v-.466Z",
    transform: "translate(-1144.019 -1230.32)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPlusLogoWhite);
export default __webpack_public_path__ + "static/media/BellPlus-LogoWhite.6daf7cf7a446adafc857b673b84705cb.svg";
export { ForwardRef as ReactComponent };